module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Italic_1.8bf40aec.ttf";